import { useEffect, useState, useRef} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import InputBase from '@material-ui/core/InputBase';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import { useDispatch, useSelector } from "react-redux";
import { formdlgclose } from '../modules/formdlgstore';
import { CellType, isEnabled, isEmpty } from '../modules/appLibrary';
import TextareaAutosize from '@mui/base/TextareaAutosize';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Checkbox from '@mui/material/Checkbox';

function PaperComponent(props) {
    return (
        <Draggable handle="#draggable-tagtool-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
}

export default function FormDialog(props) {
    const open = useSelector(state => state.formdlg.open);
    const title = useSelector(state => state.formdlg.title);
    const dialogtype = useSelector(state => state.formdlg.dialogtype);
    const contents = useSelector(state => state.formdlg.contents);
    const contents2 = useSelector(state => state.formdlg.contents2);
    const contents3 = useSelector(state => state.formdlg.contents3);
    const placeholder = useSelector(state => state.formdlg.placeholder);
    const checkboxlabel = useSelector(state => state.formdlg.checkboxlabel);
    const cmdlabel = useSelector(state => state.formdlg.cmdlabel);
    const inputname = useSelector(state => state.formdlg.inputname);
    const defaultvalue = useSelector(state => state.formdlg.defaultvalue);
    const textarea = useSelector(state => state.formdlg.textarea);
    const inputhide = useSelector(state => state.formdlg.inputhide);
    const customcontents = useSelector(state => state.formdlg.customcontents);
    const onApply = useSelector(state => state.formdlg.onApply);
    const dispatch = useDispatch();
    const CELLTYPE = CellType();

    const [value, setvalue] = useState("");
    const [note, setnote] = useState("");
    const [menushare, setmenushare] = useState("0");
    const [menup, setmenup] = useState("");

    const [share, setshare] = useState("0");
    const [read, setread] = useState("0");
    const [write, setwrite] = useState("0");
    const [readp, setreadp] = useState("");
    const [writep, setwritep] = useState("");
    const [dlg2check, setdlg2check] = useState(false);
    const [dlg3check, setdlg3check] = useState(false);
    const [dlg4check, setdlg4check] = useState(false);
    const [topposition, settopposition] = useState(280);


    const readdef = { columnid: "read", columnnm:'担当者', datatype: CELLTYPE.MASTER, dataid:'m_staff', format:'' };

    useEffect(() => {
        if (open) {
            settopposition(isEnabled(inputhide) ? 220 : 280);
            if (dialogtype === 1 && isEnabled(inputhide)) {
                setnote(defaultvalue.note);
                if (defaultvalue.read === "-1" && defaultvalue.share === "-1") {    //共有なし
                    setshare("0")
                    setread("0");
                    setreadp("");
                    setwrite("0");
                    setwritep("");
                } else {
                    if (defaultvalue.read !== "-1" && defaultvalue.share !== "-1") {    //ReadWrite
                        setshare("2")
                        setread(defaultvalue.read);
                        setreadp(defaultvalue.readp);
                        setwrite(defaultvalue.share);
                        setwritep(defaultvalue.writep);
                    } else {    //ReadOnly
                        setshare("1")
                        setread(defaultvalue.read);
                        setreadp(defaultvalue.readp);
                        setwrite("0");
                        setwritep("");
                    }
                }
            } else {
                setvalue(defaultvalue);
            }
        }
    }, [open]);

    function onClick() {
        if (value === "" && dialogtype !== 9 && !isEnabled(inputhide)) {
            props.fnc.current.warnmsg(inputname + "を入力してください");
            return;
        }
        if (dialogtype === 0 && isEmpty(customcontents)) {
            onApply(value);
            return;
        }
        if (dialogtype === 1) {     //名前を付けて保存
            if (value.length > 50) {
                props.fnc.current.warnmsg("保存名はMAX50文字です");
                return;
            }
            if (share !== "0" && read !== "0" && readp ==="") {
                props.fnc.current.warnmsg("読込権限者を入力してください");
                return;
            }
            if (share === "2" && write !== "0" && writep === "") {
                props.fnc.current.warnmsg("書込権限者を入力してください");
                return;
            }
            let param = { key: value, note: note, share: share, read: read, readp: readp, write: write, writep: writep };
            onApply(param);
            return;
        }
        let param = {};
        if (!isEmpty(customcontents)) {
            switch (customcontents) {
                case 1:     //共有条件
                    param = { option: menushare, codes: menup, name:value };
                    break;
                case 2:
                    param = { check: dlg2check, name: value };
                    break;
                case 3:
                    param = { check: dlg3check, option: menushare, codes: menup, name: value };
                    break;
                case 4:
                    param = { check: [dlg2check, dlg4check], name: value };
                    break;
                default:
                    break;
            }
        }
        onApply(param);
    }

    function ButtonClick(mode, value) {
        let param = {};
        switch (value) {
            case "1":
                param.label = "部課";
                param.dataid = "m_sect";
                break;
            case "2":
                param.label = "担当者";
                param.dataid = "m_staff";
                break;
            case "3":
                param.label = "グループ";
                param.dataid = "m_group";
                break;
            default:
                return;
        }
        props.fnc.current.searchlistopen({
            label: param.label,
            multiple: true,
            rowmode: false,
            data: { datatype: CELLTYPE.MASTER, dataid: param.dataid },
            doApply: Apply
        });
        function Apply(e) {
            switch (mode) {
                case 0:
                    setreadp(e.value);
                    break;
                case 1:
                    setwritep(e.value);
                    break;
                case 2:
                    setmenup(e.value);
                    break;
                default:
                    break;
            }
            props.fnc.current.searchlistclose();
        }
    }

    function menuChange(e) {
        setmenushare(e.target.value);
        setmenup('');
    }
   function readChange(e) {
        setread(e.target.value);
        setreadp('');
    }
    function writeChange(e) {
        setwrite(e.target.value);
        setwritep('');
    }
    function dlg2checkChange(e) {
        setdlg2check(e.target.checked);
    }
    function dlg3checkChange(e) {
        setdlg3check(e.target.checked);
    }
    function dlg4checkChange(e) {
        setdlg4check(e.target.checked);
    }

    function Extracontents() {
        if (isEmpty(customcontents)) return null;
        switch (customcontents) {
            case 1:     //共有条件
            case 3:     //共有条件 & 重要
                return (
                    <div>
                        {customcontents === 3 ?
                            <div style={{ marginTop: 5 }}>
                                <FormControlLabel
                                    control={<Checkbox size="small" color="default" checked={dlg3check} onChange={dlg3checkChange} />}
                                    label={<span style={{ fontSize: 12 }}>重要フラグを付ける</span>}
                                />
                            </div>
                            : null
                        }
                        <div style={{ marginTop:30 }}>
                            <RadioGroup
                                name="menushare"
                                row
                                value={menushare}
                                onChange={menuChange}
                            >
                                <FormControlLabel value="0"
                                    control={<Radio size="small" />}
                                    label={<span style={{ fontSize: 12 }}>すべて</span>}
                                />
                                <FormControlLabel value="1"
                                    control={<Radio size="small" />}
                                    label={<span style={{ fontSize: 12 }}>部課</span>}
                                />
                                <FormControlLabel value="2"
                                    control={<Radio size="small" />}
                                    label={<span style={{ fontSize: 12 }}>担当者</span>}
                                />
                                <FormControlLabel value="3"
                                    control={<Radio size="small" />}
                                    label={<span style={{ fontSize: 12 }}>グループ</span>}
                                />
                            </RadioGroup>
                            <TextField label=""
                                color="secondary"
                                value={menup}
                                InputProps={{
                                    readOnly: menushare === '0',
                                }}
                                onChange={(e) => setmenup(e.target.value)}
                                fullWidth focused />
                            {menushare === '0' ? null :
                                <div style={{ position: 'absolute', bottom: 60, right: 30 }}>
                                    <IconButton size="small" onClick={() => ButtonClick(2, menushare)}>
                                        <Icon>arrow_right</Icon>
                                    </IconButton>
                                </div>
                            }
                        </div>
                    </div>
                );
            case 2:
                return (
                    <div style={{ marginTop: 30 }}>
                        <FormControlLabel
                            control={<Checkbox size="small" color="default" checked={dlg2check} onChange={dlg2checkChange} />}
                            label={<span style={{ fontSize: 12 }}>{isEmpty(checkboxlabel) ? '登録レイアウトをすべて複製する' : checkboxlabel}</span>}
                        />
                    </div>
                );
            case 4:
                var labels = ["", ""];
                if (!isEmpty(checkboxlabel)) labels = checkboxlabel.split(",");
                return (
                    <div style={{ marginTop: 30 }}>
                        <FormControlLabel
                            control={<Checkbox size="small" color="default" checked={dlg2check} onChange={dlg2checkChange} />}
                            label={<span style={{ fontSize: 12 }}>{labels[0]}</span>}
                        />
                        <FormControlLabel
                            control={<Checkbox size="small" color="default" checked={dlg4check} onChange={dlg4checkChange} />}
                            label={<span style={{ fontSize: 12 }}>{labels[1]}</span>}
                        />
                    </div>
                );
            default:
                return null;
        }
    }

    return (
        <div>
            <Dialog
                open={open}
                disableBackdropClick={true}
                BackdropProps={{ invisible: true }}
                fullWidth={true}
                maxWidth={"sm"}
                PaperComponent={PaperComponent}
                PaperProps={{
                    style: {
                        backgroundColor: '#F6F6F4',
                    }
                }}
                >
                <DialogTitle style={{ cursor: 'move' }} id="draggable-tagtool-title">
                    <span style={{ fontSize:13 }}>{title}</span>
                </DialogTitle>
                <DialogContent>
                    <div>{contents}</div>
                    <div>{contents2}</div>
                    <div>{contents3}</div>

                    {dialogtype === 9 || isEnabled(inputhide) ? null :
                        textarea ?
                            <TextareaAutosize
                                autoFocus
                                minRows={4}
                                placeholder={placeholder}
                                value={value}
                                onChange={(e) => setvalue(e.target.value)}
                                style={{ width: '100%'}}
                            />
                            :<Paper component="div" className={props.classes.root} style={{ width: '100%', marginTop:10 }}>
                                <InputBase
                                    autoFocus
                                        className={props.classes.input}
                                        value={value}
                                        placeholder={placeholder}
                                        onChange={(e) => setvalue(e.target.value)}
                                    />
                            </Paper>
                    }
                    {/*名前を付けて保存*/}
                    {dialogtype !== 1 ? null :
                        <div style={{ marginTop: 20 }}>
                            <TextField label="備考"
                                color="secondary"
                                value={note}
                                onChange={(e) => setnote(e.target.value)}
                                fullWidth focused />
                            <RadioGroup
                                name="share"
                                row
                                value={share}
                                onChange={(e) => setshare(e.target.value)}
                            >
                                <FormControlLabel value="0"
                                    control={<Radio size="small" />}
                                    label={<span style={{ fontSize: 12 }}>共有しない</span>}
                                />
                                <FormControlLabel value="1"
                                    control={<Radio size="small" />}
                                    label={<span style={{ fontSize: 12 }}>共有（Readonly）</span>}
                                />
                                <FormControlLabel value="2"
                                    control={<Radio size="small" />}
                                    label={<span style={{ fontSize: 12 }}>共有（ReadWrite）</span>}
                                />
                            </RadioGroup>
                            {share === '0' ? null :
                                <div>
                                    <div>読込権限者</div>
                                    <RadioGroup
                                        name="read"
                                        row
                                        value={read}
                                        onChange={readChange}
                                    >
                                        <FormControlLabel value="0"
                                            control={<Radio size="small" />}
                                            label={<span style={{ fontSize: 12 }}>すべて</span>}
                                        />
                                        <FormControlLabel value="1"
                                            control={<Radio size="small" />}
                                            label={<span style={{ fontSize: 12 }}>部課</span>}
                                        />
                                        <FormControlLabel value="2"
                                            control={<Radio size="small" />}
                                            label={<span style={{ fontSize: 12 }}>担当者</span>}
                                        />
                                        <FormControlLabel value="3"
                                            control={<Radio size="small" />}
                                            label={<span style={{ fontSize: 12 }}>グループ</span>}
                                        />
                                    </RadioGroup>
                                    <TextField label=""
                                        color="secondary"
                                        value={readp}
                                        onChange={(e) => setreadp(e.target.value)}
                                        fullWidth focused />
                                    {read === '0' ? null :
                                        <div style={{ position: 'absolute', top: topposition, right: 30 }}>
                                            <IconButton size="small" onClick={() => ButtonClick(0,read)}>
                                                <Icon>arrow_right</Icon>
                                            </IconButton>
                                        </div>
                                    }
                                </div>
                                }
                               {share !== '2' ? null :
                                <div>
                                    <div>書込権限者</div>
                                    <RadioGroup
                                        name="write"
                                        row
                                        value={write}
                                        onChange={writeChange}
                                    >
                                        <FormControlLabel value="0"
                                            control={<Radio size="small" />}
                                            label={<span style={{ fontSize: 12 }}>すべて</span>}
                                        />
                                        <FormControlLabel value="1"
                                            control={<Radio size="small" />}
                                            label={<span style={{ fontSize: 12 }}>部課</span>}
                                        />
                                        <FormControlLabel value="2"
                                            control={<Radio size="small" />}
                                            label={<span style={{ fontSize: 12 }}>担当者</span>}
                                        />
                                        <FormControlLabel value="3"
                                            control={<Radio size="small" />}
                                            label={<span style={{ fontSize: 12 }}>グループ</span>}
                                        />
                                    </RadioGroup>
                                    <TextField label=""
                                        color="secondary"
                                        value={writep}
                                        onChange={(e) => setwritep(e.target.value)}
                                        fullWidth focused />
                                    {write === '0' ? null :
                                        <div style={{ position: 'absolute', bottom: 60, right: 30 }}>
                                            <IconButton size="small" onClick={() => ButtonClick(1,write)}>
                                                <Icon>arrow_right</Icon>
                                            </IconButton>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    }
                    <Extracontents />
                 </DialogContent>
                <DialogActions>
                    <Button onClick={onClick}>{cmdlabel}</Button>
                    {/*<Button onClick={DeleteTags}>削除</Button>*/}
                    <Button onClick={() => dispatch(formdlgclose())}>Cancel</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}